"use strict";

// Create a highchart for the #financial-info-chart div

const immFinancePage = () => {

    function getFlags(code) {
        const $code = code.toUpperCase();
        if ($code == 'AD') return '🇦🇩';
        if ($code == 'AE') return '🇦🇪';
        if ($code == 'AF') return '🇦🇫';
        if ($code == 'AG') return '🇦🇬';
        if ($code == 'AI') return '🇦🇮';
        if ($code == 'AL') return '🇦🇱';
        if ($code == 'AM') return '🇦🇲';
        if ($code == 'AO') return '🇦🇴';
        if ($code == 'AQ') return '🇦🇶';
        if ($code == 'AR') return '🇦🇷';
        if ($code == 'AS') return '🇦🇸';
        if ($code == 'AT') return '🇦🇹';
        if ($code == 'AU') return '🇦🇺';
        if ($code == 'AW') return '🇦🇼';
        if ($code == 'AX') return '🇦🇽';
        if ($code == 'AZ') return '🇦🇿';
        if ($code == 'BA') return '🇧🇦';
        if ($code == 'BB') return '🇧🇧';
        if ($code == 'BD') return '🇧🇩';
        if ($code == 'BE') return '🇧🇪';
        if ($code == 'BF') return '🇧🇫';
        if ($code == 'BG') return '🇧🇬';
        if ($code == 'BH') return '🇧🇭';
        if ($code == 'BI') return '🇧🇮';
        if ($code == 'BJ') return '🇧🇯';
        if ($code == 'BL') return '🇧🇱';
        if ($code == 'BM') return '🇧🇲';
        if ($code == 'BN') return '🇧🇳';
        if ($code == 'BO') return '🇧🇴';
        if ($code == 'BQ') return '🇧🇶';
        if ($code == 'BR') return '🇧🇷';
        if ($code == 'BS') return '🇧🇸';
        if ($code == 'BT') return '🇧🇹';
        if ($code == 'BV') return '🇧🇻';
        if ($code == 'BW') return '🇧🇼';
        if ($code == 'BY') return '🇧🇾';
        if ($code == 'BZ') return '🇧🇿';
        if ($code == 'CA') return '🇨🇦';
        if ($code == 'CC') return '🇨🇨';
        if ($code == 'CD') return '🇨🇩';
        if ($code == 'CF') return '🇨🇫';
        if ($code == 'CG') return '🇨🇬';
        if ($code == 'CH') return '🇨🇭';
        if ($code == 'CI') return '🇨🇮';
        if ($code == 'CK') return '🇨🇰';
        if ($code == 'CL') return '🇨🇱';
        if ($code == 'CM') return '🇨🇲';
        if ($code == 'CN') return '🇨🇳';
        if ($code == 'CO') return '🇨🇴';
        if ($code == 'CR') return '🇨🇷';
        if ($code == 'CU') return '🇨🇺';
        if ($code == 'CV') return '🇨🇻';
        if ($code == 'CW') return '🇨🇼';
        if ($code == 'CX') return '🇨🇽';
        if ($code == 'CY') return '🇨🇾';
        if ($code == 'CZ') return '🇨🇿';
        if ($code == 'DE') return '🇩🇪';
        if ($code == 'DJ') return '🇩🇯';
        if ($code == 'DK') return '🇩🇰';
        if ($code == 'DM') return '🇩🇲';
        if ($code == 'DO') return '🇩🇴';
        if ($code == 'DZ') return '🇩🇿';
        if ($code == 'EC') return '🇪🇨';
        if ($code == 'EE') return '🇪🇪';
        if ($code == 'EG') return '🇪🇬';
        if ($code == 'EH') return '🇪🇭';
        if ($code == 'ER') return '🇪🇷';
        if ($code == 'ES') return '🇪🇸';
        if ($code == 'ET') return '🇪🇹';
        if ($code == 'FI') return '🇫🇮';
        if ($code == 'FJ') return '🇫🇯';
        if ($code == 'FK') return '🇫🇰';
        if ($code == 'FM') return '🇫🇲';
        if ($code == 'FO') return '🇫🇴';
        if ($code == 'FR') return '🇫🇷';
        if ($code == 'GA') return '🇬🇦';
        if ($code == 'GB') return '🇬🇧';
        if ($code == 'GD') return '🇬🇩';
        if ($code == 'GE') return '🇬🇪';
        if ($code == 'GF') return '🇬🇫';
        if ($code == 'GG') return '🇬🇬';
        if ($code == 'GH') return '🇬🇭';
        if ($code == 'GI') return '🇬🇮';
        if ($code == 'GL') return '🇬🇱';
        if ($code == 'GM') return '🇬🇲';
        if ($code == 'GN') return '🇬🇳';
        if ($code == 'GP') return '🇬🇵';
        if ($code == 'GQ') return '🇬🇶';
        if ($code == 'GR') return '🇬🇷';
        if ($code == 'GS') return '🇬🇸';
        if ($code == 'GT') return '🇬🇹';
        if ($code == 'GU') return '🇬🇺';
        if ($code == 'GW') return '🇬🇼';
        if ($code == 'GY') return '🇬🇾';
        if ($code == 'HK') return '🇭🇰';
        if ($code == 'HM') return '🇭🇲';
        if ($code == 'HN') return '🇭🇳';
        if ($code == 'HR') return '🇭🇷';
        if ($code == 'HT') return '🇭🇹';
        if ($code == 'HU') return '🇭🇺';
        if ($code == 'ID') return '🇮🇩';
        if ($code == 'IE') return '🇮🇪';
        if ($code == 'IL') return '🇮🇱';
        if ($code == 'IM') return '🇮🇲';
        if ($code == 'IN') return '🇮🇳';
        if ($code == 'IO') return '🇮🇴';
        if ($code == 'IQ') return '🇮🇶';
        if ($code == 'IR') return '🇮🇷';
        if ($code == 'IS') return '🇮🇸';
        if ($code == 'IT') return '🇮🇹';
        if ($code == 'JE') return '🇯🇪';
        if ($code == 'JM') return '🇯🇲';
        if ($code == 'JO') return '🇯🇴';
        if ($code == 'JP') return '🇯🇵';
        if ($code == 'KE') return '🇰🇪';
        if ($code == 'KG') return '🇰🇬';
        if ($code == 'KH') return '🇰🇭';
        if ($code == 'KI') return '🇰🇮';
        if ($code == 'KM') return '🇰🇲';
        if ($code == 'KN') return '🇰🇳';
        if ($code == 'KP') return '🇰🇵';
        if ($code == 'KR') return '🇰🇷';
        if ($code == 'KW') return '🇰🇼';
        if ($code == 'KY') return '🇰🇾';
        if ($code == 'KZ') return '🇰🇿';
        if ($code == 'LA') return '🇱🇦';
        if ($code == 'LB') return '🇱🇧';
        if ($code == 'LC') return '🇱🇨';
        if ($code == 'LI') return '🇱🇮';
        if ($code == 'LK') return '🇱🇰';
        if ($code == 'LR') return '🇱🇷';
        if ($code == 'LS') return '🇱🇸';
        if ($code == 'LT') return '🇱🇹';
        if ($code == 'LU') return '🇱🇺';
        if ($code == 'LV') return '🇱🇻';
        if ($code == 'LY') return '🇱🇾';
        if ($code == 'MA') return '🇲🇦';
        if ($code == 'MC') return '🇲🇨';
        if ($code == 'MD') return '🇲🇩';
        if ($code == 'ME') return '🇲🇪';
        if ($code == 'MF') return '🇲🇫';
        if ($code == 'MG') return '🇲🇬';
        if ($code == 'MH') return '🇲🇭';
        if ($code == 'MK') return '🇲🇰';
        if ($code == 'ML') return '🇲🇱';
        if ($code == 'MM') return '🇲🇲';
        if ($code == 'MN') return '🇲🇳';
        if ($code == 'MO') return '🇲🇴';
        if ($code == 'MP') return '🇲🇵';
        if ($code == 'MQ') return '🇲🇶';
        if ($code == 'MR') return '🇲🇷';
        if ($code == 'MS') return '🇲🇸';
        if ($code == 'MT') return '🇲🇹';
        if ($code == 'MU') return '🇲🇺';
        if ($code == 'MV') return '🇲🇻';
        if ($code == 'MW') return '🇲🇼';
        if ($code == 'MX') return '🇲🇽';
        if ($code == 'MY') return '🇲🇾';
        if ($code == 'MZ') return '🇲🇿';
        if ($code == 'NA') return '🇳🇦';
        if ($code == 'NC') return '🇳🇨';
        if ($code == 'NE') return '🇳🇪';
        if ($code == 'NF') return '🇳🇫';
        if ($code == 'NG') return '🇳🇬';
        if ($code == 'NI') return '🇳🇮';
        if ($code == 'NL') return '🇳🇱';
        if ($code == 'NO') return '🇳🇴';
        if ($code == 'NP') return '🇳🇵';
        if ($code == 'NR') return '🇳🇷';
        if ($code == 'NU') return '🇳🇺';
        if ($code == 'NZ') return '🇳🇿';
        if ($code == 'OM') return '🇴🇲';
        if ($code == 'PA') return '🇵🇦';
        if ($code == 'PE') return '🇵🇪';
        if ($code == 'PF') return '🇵🇫';
        if ($code == 'PG') return '🇵🇬';
        if ($code == 'PH') return '🇵🇭';
        if ($code == 'PK') return '🇵🇰';
        if ($code == 'PL') return '🇵🇱';
        if ($code == 'PM') return '🇵🇲';
        if ($code == 'PN') return '🇵🇳';
        if ($code == 'PR') return '🇵🇷';
        if ($code == 'PS') return '🇵🇸';
        if ($code == 'PT') return '🇵🇹';
        if ($code == 'PW') return '🇵🇼';
        if ($code == 'PY') return '🇵🇾';
        if ($code == 'QA') return '🇶🇦';
        if ($code == 'RE') return '🇷🇪';
        if ($code == 'RO') return '🇷🇴';
        if ($code == 'RS') return '🇷🇸';
        if ($code == 'RU') return '🇷🇺';
        if ($code == 'RW') return '🇷🇼';
        if ($code == 'SA') return '🇸🇦';
        if ($code == 'SB') return '🇸🇧';
        if ($code == 'SC') return '🇸🇨';
        if ($code == 'SD') return '🇸🇩';
        if ($code == 'SE') return '🇸🇪';
        if ($code == 'SG') return '🇸🇬';
        if ($code == 'SH') return '🇸🇭';
        if ($code == 'SI') return '🇸🇮';
        if ($code == 'SJ') return '🇸🇯';
        if ($code == 'SK') return '🇸🇰';
        if ($code == 'SL') return '🇸🇱';
        if ($code == 'SM') return '🇸🇲';
        if ($code == 'SN') return '🇸🇳';
        if ($code == 'SO') return '🇸🇴';
        if ($code == 'SR') return '🇸🇷';
        if ($code == 'SS') return '🇸🇸';
        if ($code == 'ST') return '🇸🇹';
        if ($code == 'SV') return '🇸🇻';
        if ($code == 'SX') return '🇸🇽';
        if ($code == 'SY') return '🇸🇾';
        if ($code == 'SZ') return '🇸🇿';
        if ($code == 'TC') return '🇹🇨';
        if ($code == 'TD') return '🇹🇩';
        if ($code == 'TF') return '🇹🇫';
        if ($code == 'TG') return '🇹🇬';
        if ($code == 'TH') return '🇹🇭';
        if ($code == 'TJ') return '🇹🇯';
        if ($code == 'TK') return '🇹🇰';
        if ($code == 'TL') return '🇹🇱';
        if ($code == 'TM') return '🇹🇲';
        if ($code == 'TN') return '🇹🇳';
        if ($code == 'TO') return '🇹🇴';
        if ($code == 'TR') return '🇹🇷';
        if ($code == 'TT') return '🇹🇹';
        if ($code == 'TV') return '🇹🇻';
        if ($code == 'TW') return '🇹🇼';
        if ($code == 'TZ') return '🇹🇿';
        if ($code == 'UA') return '🇺🇦';
        if ($code == 'UG') return '🇺🇬';
        if ($code == 'UM') return '🇺🇲';
        if ($code == 'US') return '🇺🇸';
        if ($code == 'UY') return '🇺🇾';
        if ($code == 'UZ') return '🇺🇿';
        if ($code == 'VA') return '🇻🇦';
        if ($code == 'VC') return '🇻🇨';
        if ($code == 'VE') return '🇻🇪';
        if ($code == 'VG') return '🇻🇬';
        if ($code == 'VI') return '🇻🇮';
        if ($code == 'VN') return '🇻🇳';
        if ($code == 'VU') return '🇻🇺';
        if ($code == 'WF') return '🇼🇫';
        if ($code == 'WS') return '🇼🇸';
        if ($code == 'XK') return '🇽🇰';
        if ($code == 'YE') return '🇾🇪';
        if ($code == 'YT') return '🇾🇹';
        if ($code == 'ZA') return '🇿🇦';
        if ($code == 'ZM') return '🇿🇲';
        return '🏳';
    }

    let immInfoFinanciare = {
        2020: {
            cifraAfaceri: 100000,
            cheltuieli: 50000,
            profitNetAnual: 50000,
            totalActive: 100000,
            marjaProfitBrut: 2000,
            marjaOperationata: 3000,
            marjaProfitNet: 2000,
            datorieNeta: 1000,
            raportDatoriiCapitaluriProprii: 1.5,
            rataLichididateRapida: 2000,
            rataAcoperireServiciuDatorie: 2000,
            EBIDTA: 2000,
            rentabilitateaCapitaluluiPropriu: 2000,
            raportulImobilizarileNecorporaleSiActive: 10,
            numarAngajati: 5,
        },
        2021: {
            cifraAfaceri: 120000,
            cheltuieli: 52000,
            profitNetAnual: 55000,
            totalActive: 100000,
            marjaProfitBrut: 2000,
            marjaOperationata: 3000,
            marjaProfitNet: 2000,
            datorieNeta: 1000,
            raportDatoriiCapitaluriProprii: 1.5,
            rataLichididateRapida: 2000,
            rataAcoperireServiciuDatorie: 2000,
            EBIDTA: 2000,
            rentabilitateaCapitaluluiPropriu: 2000,
            raportulImobilizarileNecorporaleSiActive: 10,
            numarAngajati: 5,
        },
        2022: {
            cifraAfaceri: 150000,
            cheltuieli: 78000,
            profitNetAnual: 60000,
            totalActive: 100000,
            marjaProfitBrut: 1000,
            marjaOperationata: 3000,
            marjaProfitNet: 1800,
            datorieNeta: 1200,
            raportDatoriiCapitaluriProprii: 1.5,
            rataLichididateRapida: 3000,
            rataAcoperireServiciuDatorie: 2000,
            EBIDTA: 1000,
            rentabilitateaCapitaluluiPropriu: 1800,
            raportulImobilizarileNecorporaleSiActive: 10,
            numarAngajati: 5,
        }
    };

    const immInfoFinanciareLabels = {
        cifraAfaceri: 'Cifra de afaceri',
        cheltuieli: 'Cheltuieli',
        profitNetAnual: 'Profit net anual',
        totalActive: 'Total active',
        marjaProfitBrut: 'Marja profit brut',
        marjaProfitNet: 'Marja profit net',
        datorieNeta: 'Datorie neta',
        raportDatoriiCapitaluriProprii: 'Raport datorii capitaluri proprii',
        rataLichididateRapida: 'Rata lichididate rapida',
        rataAcoperireServiciuDatorie: 'Rata acoperire serviciu datorie',
        EBIDTA: 'EBIDTA',
        rentabilitateaCapitaluluiPropriu: 'Rentabilitatea capitalului propriu',
        raportulImobilizarileNecorporaleSiActive: 'Raportul imobilizarile necorporale si active',
        numarAngajati: 'Numar angajati',
        marjaOperationata: 'Marja operațională',
    };

    // const immInfoFinanciareData = Object.keys(immInfoFinanciare).map((year) => {
    //     return {
    //         name: year,
    //         data: [
    //             immInfoFinanciare[year].cifraAfaceri,
    //             immInfoFinanciare[year].cheltuieli,
    //             immInfoFinanciare[year].profit,
    //         ]
    //     };
    // });

    const immInfoFinanciareData = [
        {
            name: 'Cifra de afaceri',
            borderColor: '#5DCFF7',
            borderWidth: 1,
            color: {
                linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                stops: [
                    [0, '#5DCFF7'],
                    [1, 'rgba(93, 207, 247, 0.3)']
                ]
            },
            data: Object.keys(immInfoFinanciare).map((year) => {
                return immInfoFinanciare[year].cifraAfaceri;
            })
        },
        {
            name: 'Cheltuieli',
            borderWidth: 1,
            borderColor: '#F9C305',
            color: {
                linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                stops: [
                    [0, '#F9C305'],
                    [1, 'rgba(249, 194, 1, 0.3)']
                ]
            },
            data: Object.keys(immInfoFinanciare).map((year) => {
                return immInfoFinanciare[year].cheltuieli;
            })
        },
        {
            name: 'Profit',
            color: {
                linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                stops: [
                    [0, '#70DF7C'],
                    [1, 'rgba(112, 223, 124, 0.3)']
                ]
            },
            borderWidth: 1,
            borderColor: '#72DF7D',
            data: Object.keys(immInfoFinanciare).map((year) => {
                return immInfoFinanciare[year].profitNetAnual;
            })
        },
    ];

    const formatMoney = (amount, prefix = '€') => {
        return prefix + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }


    const xAxisCategories = Object.keys(immInfoFinanciare).map((year) => {
        return year;
    });

    const fetchImmSingleData = (id = '', callback = function () { }) => {
        // Fetch the data from the API via fetch
        // The id is the id of the company
        // The callback is the function that will be called after the data is fetched
        // The callback will receive the data as a parameter

        // The data should be stored in the immInfoFinanciare object
        // The immInfoFinanciare object should be an object with the years as keys and the values as objects
        // The values object should have the keys as the keys of the immInfoFinanciareLabels object
        // The values object should have the values as the values of the immInfoFinanciareLabels object

        // const url = 'https://touchsize.com/clients/fagura/single_imm.json';

        // Get id from the url from format fagura.com/imm-single.html?id=123
        const urlParams = new URLSearchParams(window.location.search);
        const entityId = urlParams.get('id');
        const url = 'https://api.fagura.ro/api/public/imm-loans/' + entityId;


        fetch(url)
            .then(response => response.json())
            .then(data => {

                // console.log(data[0]);

                // immInfoFinanciare = {
                //     [data[0].financialBalanceSheet[0]['date']]: {
                //         cifraAfaceri: data[0].financialBalanceSheet[0]['capital'],
                //         cheltuieli: data[0].financialBalanceSheet[0]['active'],
                //         profitNetAnual: 50000,
                //         totalActive: 100000,
                //         marjaProfitBrut: 2000,
                //         marjaOperationata: 3000,
                //         marjaProfitNet: 2000,
                //         datorieNeta: 1000,
                //         raportDatoriiCapitaluriProprii: 1.5,
                //         rataLichididateRapida: 2000,
                //         rataAcoperireServiciuDatorie: 2000,
                //         EBIDTA: 2000,
                //         rentabilitateaCapitaluluiPropriu: 2000,
                //         raportulImobilizarileNecorporaleSiActive: 10,
                //         numarAngajati: 5,
                //     },
                //     [data[0].financialBalanceSheet[1]['date']]: {

                //     },
                //     [data[0].financialBalanceSheet[2]['date']]: {

                //     }
                // }

                // console.log(immInfoFinanciare);

                // Here's a list of repos!
                // 1. Find the H1 on the page and replace the text with the name of the company from data[0]['cpCompanyName]
                jQuery('h1').text(data[0]['cpCompanyName'].replace('Societatea cu Răspundere Limitată ', '')).removeClass('skeleton-load');
                jQuery('.entity-id').text('ID împrumut: ' + data[0]['loanId'] + '/' + data[0].appPublicId).removeClass('skeleton-load');
                jQuery('#entity-registration-date').text(new Date(data[0]['registrationDate']).toLocaleDateString('ro-RO', { year: 'numeric', month: 'long', day: 'numeric' })).removeClass('skeleton-load');
                jQuery('#entity-idno').text(data[0]['IDNO']).removeClass('skeleton-load');
                jQuery('#entity-address').text(data[0]['address']).removeClass('skeleton-load');
                jQuery('#entity-address').attr('href', 'https://www.google.com/maps/search/?api=1&query=' + data[0]['address']);
                jQuery('#investors-counter').text(data[0]['nrOfInvestors']).removeClass('skeleton-load');
                jQuery('#days-left-counter').text(data[0]['daysLeft']).removeClass('skeleton-load');
                jQuery('#entity-verify-url').attr('href', 'https://date.gov.md/open/company-details?idno=' + data[0]['IDNO']).removeClass('skeleton-load');
                if (data[0]['website']) {
                    jQuery('#entity-website').attr('href', data[0]['website']).removeClass('skeleton-load');
                    jQuery('#entity-website').text(data[0]['website'] && data[0]['website'].startsWith('https://') ? data[0]['website'].replace('https://', '') : data[0]['website']);
                } else {
                    jQuery('#entity-website').parents('li').hide();
                }
                jQuery('#entity-collected-amount').text(formatMoney(parseInt(data[0]['collectedAmount']))).removeClass('skeleton-load');
                jQuery('#entity-loan-amount').text(formatMoney(parseInt(data[0]['loanAmount']))).removeClass('skeleton-load');
                jQuery('#entity-interest-rate').text(data[0]['scoringResult']['interest'] + '%').removeClass('skeleton-load');
                jQuery('#entity-interest-rate').parent().width(data[0]['scoringResult']['interest'] + '%');
                jQuery('#entity-bic-checks').text(data[0]['totalBICchecks']).removeClass('skeleton-load');
                jQuery('#entity-loan-period').text(data[0]['loanPeriod']).removeClass('skeleton-load');
                jQuery('#entity-effective-beneficiary').text(data[0]['effectiveBeneficiary']).removeClass('skeleton-load');
                jQuery('#entity-active-credits').text(formatMoney(data[0]['totalActiveCredits'])).removeClass('skeleton-load');
                jQuery('#entity-other-active-credits').text(data[0]['otherActiveCredits'] ? formatMoney(data[0]['otherActiveCredits'].toFixed(1)) : '').removeClass('skeleton-load');
                jQuery('#entity-monthly-payments').text(formatMoney(parseFloat(data[0]['monthlyPaymentToCredits']).toFixed(1))).removeClass('skeleton-load');
                jQuery('#entity-own-contribution').text(data[0]['ownContribution'] ? formatMoney(parseFloat(data[0]['ownContribution'].toFixed(1))) : '').removeClass('skeleton-load');
                jQuery('#entity-description').text(data[0]['projectName']).removeClass('skeleton-load');
                jQuery('#entity-activities').text(data[0]['domainsOfActivity'].splice(0, 5).map((activity) => { return ' ' + activity.Code }) + (data[0]['domainsOfActivity'].length > 5 ? ' ...' : '')).removeClass('skeleton-load');
                jQuery('#entity-associates').text(data[0]['associates'].map((user) => { return user.FirstName + ' ' + user.LastName })).removeClass('skeleton-load');

                jQuery('#entity-administrator').attr('href', data[0].linkedInAdmin);
                jQuery('#entity-administrator span').text(data[0].administrator.name).removeClass('skeleton-load');
                if (!data[0].linkedInAdmin) {
                    jQuery('#entity-administrator svg').remove();
                    // Change the <a> to a <span>
                    jQuery('#entity-administrator').replaceWith(function () {
                        return jQuery('<div/>', {
                            html: this.innerHTML
                        });
                    });
                }

                if (data[0]['scoringResult']['degree'].startsWith('A', 0)) {
                    jQuery('.risk-badge').addClass('green');
                } else if (data[0]['scoringResult']['degree'].startsWith('B', 0)) {
                    jQuery('.risk-badge').addClass('blue');
                } else if (data[0]['scoringResult']['degree'].startsWith('C', 0)) {
                    jQuery('.risk-badge').addClass('yellow');
                } else if (data[0]['scoringResult']['degree'].startsWith('D', 0)) {
                    jQuery('.risk-badge').addClass('yellow');
                } else if (data[0]['scoringResult']['degree'].startsWith('E', 0)) {
                    jQuery('.risk-badge').addClass('orange');
                } else if (data[0]['scoringResult']['degree'].startsWith('F', 0)) {
                    jQuery('.risk-badge').addClass('red');
                } else if (data[0]['scoringResult']['degree'].startsWith('G', 0)) {
                    jQuery('.risk-badge').addClass('red');
                }

                jQuery('.risk-badge .risk-letter').text(data[0]['scoringResult']['degree'][0]);
                jQuery('.risk-badge .risk-number').text(data[0]['scoringResult']['degree'][1]);

                let percentage = parseFloat(data[0]['collectedAmount']) * 100 / parseInt(data[0]['loanAmount']);
                jQuery('#entity-funding-percentage').text(percentage.toFixed(1) + '%').parent().css('width', percentage.toFixed(1) + '%');

                if (percentage == 100) {
                    jQuery('.progress-bar').addClass('funded');
                }


                let scoring = parseFloat(data[0]['scoringResult']['score']);
                let scoringTitle = '';
                let scoringClass = 'risk-1';
                if (scoring <= 20) {
                    scoringTitle = 'Scăzut';
                } else if (scoring > 20 && scoring <= 40) {
                    scoringTitle = 'Scăzut moderat';
                    scoringClass = 'risk-2';
                } else if (scoring > 40 && scoring <= 60) {
                    scoringTitle = 'Moderat';
                    scoringClass = 'risk-3';
                } else if (scoring > 60 && scoring <= 80) {
                    scoringTitle = 'Ridicat moderat';
                    scoringClass = 'risk-4';
                } else if (scoring <= 100 && scoring > 80) {
                    scoringTitle = 'Ridicat';
                    scoringClass = 'risk-5';
                }

                jQuery('#entity-risk-title').text(scoringTitle);
                jQuery('#entity-risk-title').prev().addClass(scoringClass);

                if (data[0]['promoVideo']) {
                    jQuery('#tab-pitch #entity-promo-video').html('<iframe frameBorder="0" border="0" src="' + data[0]['promoVideo'] + '"></iframe>');
                }
                jQuery('#tab-pitch #entity-pitch').html(data[0]['pitch']);
                jQuery('#tab-pitch #entity-activity-description').html(data[0]['activityDescription']);
                jQuery('#tab-pitch #entity-achievements').html(data[0]['achievementsAndRewards']);
                jQuery('#tab-pitch #entity-team-members').html(data[0]['teamMembers']);
                jQuery('#tab-pitch #entity-business-risk').html(data[0]['businessRisks']);
                jQuery('#tab-pitch #entity-money-distribution').html(data[0]['moneyDescription']);




                if (data[0]['additionalDocuments'].length > 0) {
                    // For each document, generate a link
                    let documents = '';
                    data[0]['additionalDocuments'].forEach((document) => {
                        documents += `<li><a target="_blank" href="${document.publicUrl}">
                        <svg viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.9999 7.40001V0.200012H2.7999C2.16338 0.200012 1.55293 0.452869 1.10285 0.902956C0.652758 1.35304 0.399902 1.96349 0.399902 2.60001V23.4C0.399902 24.0365 0.652758 24.647 1.10285 25.0971C1.55293 25.5472 2.16338 25.8 2.7999 25.8H17.1999C17.8364 25.8 18.4469 25.5472 18.897 25.0971C19.347 24.647 19.5999 24.0365 19.5999 23.4V9.80001H12.3999C11.7634 9.80001 11.1529 9.54716 10.7028 9.09707C10.2528 8.64698 9.9999 8.03653 9.9999 7.40001ZM3.5999 13.8C3.5999 13.5878 3.68419 13.3844 3.83422 13.2343C3.98425 13.0843 4.18773 13 4.3999 13C4.61208 13 4.81556 13.0843 4.96559 13.2343C5.11562 13.3844 5.1999 13.5878 5.1999 13.8C5.1999 14.0122 5.11562 14.2157 4.96559 14.3657C4.81556 14.5157 4.61208 14.6 4.3999 14.6C4.18773 14.6 3.98425 14.5157 3.83422 14.3657C3.68419 14.2157 3.5999 14.0122 3.5999 13.8ZM3.5999 17C3.5999 16.7878 3.68419 16.5844 3.83422 16.4343C3.98425 16.2843 4.18773 16.2 4.3999 16.2C4.61208 16.2 4.81556 16.2843 4.96559 16.4343C5.11562 16.5844 5.1999 16.7878 5.1999 17C5.1999 17.2122 5.11562 17.4157 4.96559 17.5657C4.81556 17.7157 4.61208 17.8 4.3999 17.8C4.18773 17.8 3.98425 17.7157 3.83422 17.5657C3.68419 17.4157 3.5999 17.2122 3.5999 17ZM3.5999 20.2C3.5999 19.9878 3.68419 19.7844 3.83422 19.6343C3.98425 19.4843 4.18773 19.4 4.3999 19.4C4.61208 19.4 4.81556 19.4843 4.96559 19.6343C5.11562 19.7844 5.1999 19.9878 5.1999 20.2C5.1999 20.4122 5.11562 20.6157 4.96559 20.7657C4.81556 20.9157 4.61208 21 4.3999 21C4.18773 21 3.98425 20.9157 3.83422 20.7657C3.68419 20.6157 3.5999 20.4122 3.5999 20.2ZM6.7999 13.8C6.7999 13.5878 6.88419 13.3844 7.03422 13.2343C7.18425 13.0843 7.38773 13 7.5999 13H15.5999C15.8121 13 16.0156 13.0843 16.1656 13.2343C16.3156 13.3844 16.3999 13.5878 16.3999 13.8C16.3999 14.0122 16.3156 14.2157 16.1656 14.3657C16.0156 14.5157 15.8121 14.6 15.5999 14.6H7.5999C7.38773 14.6 7.18425 14.5157 7.03422 14.3657C6.88419 14.2157 6.7999 14.0122 6.7999 13.8ZM6.7999 17C6.7999 16.7878 6.88419 16.5844 7.03422 16.4343C7.18425 16.2843 7.38773 16.2 7.5999 16.2H15.5999C15.8121 16.2 16.0156 16.2843 16.1656 16.4343C16.3156 16.5844 16.3999 16.7878 16.3999 17C16.3999 17.2122 16.3156 17.4157 16.1656 17.5657C16.0156 17.7157 15.8121 17.8 15.5999 17.8H7.5999C7.38773 17.8 7.18425 17.7157 7.03422 17.5657C6.88419 17.4157 6.7999 17.2122 6.7999 17ZM6.7999 20.2C6.7999 19.9878 6.88419 19.7844 7.03422 19.6343C7.18425 19.4843 7.38773 19.4 7.5999 19.4H15.5999C15.8121 19.4 16.0156 19.4843 16.1656 19.6343C16.3156 19.7844 16.3999 19.9878 16.3999 20.2C16.3999 20.4122 16.3156 20.6157 16.1656 20.7657C16.0156 20.9157 15.8121 21 15.5999 21H7.5999C7.38773 21 7.18425 20.9157 7.03422 20.7657C6.88419 20.6157 6.7999 20.4122 6.7999 20.2ZM11.5999 7.40001V0.600012L19.1999 8.20001H12.3999C12.1877 8.20001 11.9842 8.11573 11.8342 7.9657C11.6842 7.81567 11.5999 7.61219 11.5999 7.40001Z" fill="currentColor"></path>
                        </svg>
                        <span>${document.name}</span>
                    </a></li>`;
                    }
                    );

                    // jQuery('#tab-documents ul.document-list').html(documents);

                }

                if (data[0]['investors'].length > 0) {
                    let investors = '';
                    data[0]['investors'].forEach((investor) => {
                        investors += `<div class="investor">
                        <div class="investor-avatar">
                            <img src="images/undefined-user.png" alt="${investor.fullName}">
                        </div>
                        <div class="investor-info">
                            <div class="investor-name">${investor.fullName}</div>
                            <div class="investor-meta">
                                <strong>${formatMoney(investor.amount)}</strong>
                                <span>
                                    ${investor.country}
                                </span>
                            </div>
                        </div>
                    </div>`;
                    }
                    );

                    jQuery('#tab-investors .investors-list').html(investors);
                    jQuery('#entity-investor-count').text('(' + data[0]['nrOfInvestors'] + ')');
                }

                jQuery('#entity-credit-duration').text(data[0]['creditHistoryDuration']).removeClass('skeleton-load');
                jQuery('#entity-credit-penalties').text(data[0]['creditPenalties']).removeClass('skeleton-load');

                if (data[0]['promoPicture'].length) {

                    // Unslick existing carousels
                    if (jQuery('.imm-company-carousel').hasClass('slick-initialized')) {
                        jQuery('.imm-company-carousel').slick('unslick');
                        jQuery('.imm-company-carousel-thumbs').slick('unslick');
                    }

                    let promoImages = '';
                    if (data[0]['promoPicture'].length > 1) {
                        promoImages += '<div class="imm-company-carousel">';
                        data[0]['promoPicture'].forEach((image) => {
                            promoImages += `<figure class="imm-company-carousel-item">
                            <img src="${image.publicUrl}" alt="${image.name}">
                        </figure>`;
                        });
                        promoImages += '</div>';

                        promoImages += '<div class="imm-company-carousel-thumbs">';
                        data[0]['promoPicture'].forEach((image) => {
                            promoImages += `<figure class="imm-company-carousel-item">
                            <img src="${image.publicUrl}" alt="${image.name}">
                        </figure>`;
                        });
                        promoImages += '</div>';

                        jQuery('#entity-promo-images').html(promoImages);

                        // Initialize the carousel
                        initiliazeCarousel();

                    } else if (data[0]['promoPicture'].length == 1) {
                        promoImages = `<figure class="imm-company-carousel-item">
                        <img src="${data[0]['promoPicture'][0].publicUrl}" alt="${data[0]['promoPicture'][0].name}">
                    </figure>`;
                        jQuery('#entity-promo-images').html(promoImages);
                    }

                    // Set the meta image for social media the first image from the carousel
                    jQuery('meta[property="og:image"]').attr('content', data[0]['promoPicture'][0].publicUrl);

                    // Change the title of the page
                    jQuery('title').text(data[0]['cpCompanyName'] + ' - Finanțare IMM');

                }

                // Create social media links
                let socialMediaLinks = '';
                if (data[0].socialMedia) {
                    if (data[0].socialMedia.facebook) {
                        socialMediaLinks += `<a class="facebook" href="${data[0].socialMedia.facebook}">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.32118 14L6.30303 8.24246H4V5.93943H6.30303V4.50004C6.30303 2.36317 7.62631 1.33337 9.53254 1.33337C10.4456 1.33337 11.2304 1.40135 11.4591 1.43174V3.66489L10.137 3.66549C9.10032 3.66549 8.89959 4.15812 8.89959 4.88103V5.93943H11.9167L10.7652 8.24246H8.89959V14H6.32118Z" fill="currentColor"></path>
                        </svg>
                        </a>`;
                    }

                    if (data[0].socialMedia.twitter) {
                        socialMediaLinks += `<a class="twitter" rel="noopener noreferrer" target="_blank" href="${data[0].socialMedia.twitter}">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.8083 3.7707C14.2994 3.99583 13.7597 4.1437 13.2071 4.20941C13.7893 3.86088 14.2249 3.3126 14.4329 2.6667C13.8858 2.99174 13.287 3.22051 12.6625 3.34307C12.1354 2.78071 11.3987 2.46202 10.6279 2.46289C9.0884 2.46289 7.8398 3.71107 7.8398 5.25122C7.8398 5.46972 7.86487 5.68161 7.91174 5.88606C5.59365 5.76936 3.54005 4.66003 2.16452 2.97294C1.91686 3.39845 1.7867 3.88212 1.78736 4.37445C1.78736 5.34173 2.27974 6.19549 3.02766 6.69533C2.58492 6.68133 2.15192 6.56176 1.76479 6.34649C1.76436 6.3582 1.76436 6.36991 1.76436 6.38099C1.76436 7.73227 2.72546 8.85947 4.00133 9.1154C3.76187 9.1802 3.51488 9.21293 3.26682 9.21273C3.08665 9.21273 2.91181 9.19613 2.74186 9.16353C3.09688 10.271 4.12591 11.0773 5.3464 11.0994C4.35876 11.8745 3.13913 12.2951 1.88362 12.2933C1.66142 12.2935 1.4394 12.2803 1.21875 12.2541C2.49336 13.0735 3.97702 13.5083 5.49228 13.5067C10.6211 13.5067 13.4253 9.25833 13.4253 5.57407C13.4253 5.45353 13.4224 5.33257 13.4171 5.21331C13.9629 4.81897 14.434 4.33045 14.8083 3.7707Z" fill="currentColor"></path>
                            </svg>
                        </a>`;
                    }

                    if (data[0].socialMedia.linkedin) {
                        socialMediaLinks += `<a class="linkedin" rel="noopener noreferrer" target="_blank" href="${data[0].socialMedia.linkedin}">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.6269 3.33333C4.62666 3.8762 4.2973 4.36472 3.79414 4.56853C3.29098 4.77234 2.7145 4.65074 2.33652 4.26107C1.95854 3.8714 1.85455 3.29147 2.07359 2.79475C2.29263 2.29803 2.79095 1.98371 3.33357 1.99999C4.05428 2.02163 4.62723 2.61229 4.6269 3.33333ZM4.6669 5.65333H2.00024V14H4.6669V5.65333ZM8.88025 5.65333H6.2269V14H8.85359V9.61997C8.85359 7.17997 12.0336 6.95331 12.0336 9.61997V14H14.6669V8.71331C14.6669 4.59999 9.96025 4.75333 8.85359 6.77331L8.88025 5.65333Z" fill="currentColor"></path>
                            </svg>
                        </a>`;
                    }

                    if (data[0].socialMedia.instagram) {
                        socialMediaLinks += `<a class="instagram" rel="noopener noreferrer" target="_blank" href="${data[0].socialMedia.instagram}">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.001 9C10.3436 9 9.00098 10.3431 9.00098 12C9.00098 13.6573 10.3441 15 12.001 15C13.6583 15 15.001 13.6569 15.001 12C15.001 10.3427 13.6579 9 12.001 9ZM12.001 7C14.7614 7 17.001 9.2371 17.001 12C17.001 14.7605 14.7639 17 12.001 17C9.24051 17 7.00098 14.7629 7.00098 12C7.00098 9.23953 9.23808 7 12.001 7ZM18.501 6.74915C18.501 7.43926 17.9402 7.99917 17.251 7.99917C16.5609 7.99917 16.001 7.4384 16.001 6.74915C16.001 6.0599 16.5617 5.5 17.251 5.5C17.9393 5.49913 18.501 6.0599 18.501 6.74915ZM12.001 4C9.5265 4 9.12318 4.00655 7.97227 4.0578C7.18815 4.09461 6.66253 4.20007 6.17416 4.38967C5.74016 4.55799 5.42709 4.75898 5.09352 5.09255C4.75867 5.4274 4.55804 5.73963 4.3904 6.17383C4.20036 6.66332 4.09493 7.18811 4.05878 7.97115C4.00703 9.0752 4.00098 9.46105 4.00098 12C4.00098 14.4745 4.00753 14.8778 4.05877 16.0286C4.0956 16.8124 4.2012 17.3388 4.39034 17.826C4.5591 18.2606 4.7605 18.5744 5.09246 18.9064C5.42863 19.2421 5.74179 19.4434 6.17187 19.6094C6.66619 19.8005 7.19148 19.9061 7.97212 19.9422C9.07618 19.9939 9.46203 20 12.001 20C14.4755 20 14.8788 19.9934 16.0296 19.9422C16.8117 19.9055 17.3385 19.7996 17.827 19.6106C18.2604 19.4423 18.5752 19.2402 18.9074 18.9085C19.2436 18.5718 19.4445 18.2594 19.6107 17.8283C19.8013 17.3358 19.9071 16.8098 19.9432 16.0289C19.9949 14.9248 20.001 14.5389 20.001 12C20.001 9.52552 19.9944 9.12221 19.9432 7.97137C19.9064 7.18906 19.8005 6.66149 19.6113 6.17318C19.4434 5.74038 19.2417 5.42635 18.9084 5.09255C18.573 4.75715 18.2616 4.55693 17.8271 4.38942C17.338 4.19954 16.8124 4.09396 16.0298 4.05781C14.9258 4.00605 14.5399 4 12.001 4ZM12.001 2C14.7176 2 15.0568 2.01 16.1235 2.06C17.1876 2.10917 17.9135 2.2775 18.551 2.525C19.2101 2.77917 19.7668 3.1225 20.3226 3.67833C20.8776 4.23417 21.221 4.7925 21.476 5.45C21.7226 6.08667 21.891 6.81333 21.941 7.8775C21.9885 8.94417 22.001 9.28333 22.001 12C22.001 14.7167 21.991 15.0558 21.941 16.1225C21.8918 17.1867 21.7226 17.9125 21.476 18.55C21.2218 19.2092 20.8776 19.7658 20.3226 20.3217C19.7668 20.8767 19.2076 21.22 18.551 21.475C17.9135 21.7217 17.1876 21.89 16.1235 21.94C15.0568 21.9875 14.7176 22 12.001 22C9.28431 22 8.94514 21.99 7.87848 21.94C6.81431 21.8908 6.08931 21.7217 5.45098 21.475C4.79264 21.2208 4.23514 20.8767 3.67931 20.3217C3.12348 19.7658 2.78098 19.2067 2.52598 18.55C2.27848 17.9125 2.11098 17.1867 2.06098 16.1225C2.01348 15.0558 2.00098 14.7167 2.00098 12C2.00098 9.28333 2.01098 8.94417 2.06098 7.8775C2.11014 6.8125 2.27848 6.0875 2.52598 5.45C2.78014 4.79167 3.12348 4.23417 3.67931 3.67833C4.23514 3.1225 4.79348 2.78 5.45098 2.525C6.08848 2.2775 6.81348 2.11 7.87848 2.06C8.94514 2.0125 9.28431 2 12.001 2Z" fill="currentColor"></path>
                        </svg>

                    </a>`;
                    }

                    if (data[0].socialMedia.telegram) {
                        socialMediaLinks += `<a class="telegram" rel="noopener noreferrer" target="_blank" href="${data[0].socialMedia.telegram}">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.00067 14.6667C4.31875 14.6667 1.33398 11.6819 1.33398 8.00004C1.33398 4.31814 4.31875 1.33337 8.00067 1.33337C11.6825 1.33337 14.6673 4.31814 14.6673 8.00004C14.6673 11.6819 11.6825 14.6667 8.00067 14.6667ZM5.92742 8.78057L5.93585 8.77524C6.32234 10.0512 6.51558 10.6892 6.51558 10.6892C6.59042 10.8962 6.69333 10.9331 6.8182 10.9162C6.943 10.8993 7.00926 10.8318 7.09073 10.7532C7.09073 10.7532 7.35493 10.4982 7.88333 9.98824L9.58393 11.2466C9.8938 11.4178 10.1175 11.3294 10.1945 10.9585L11.2997 5.74431C11.4217 5.25899 11.2077 5.06433 10.8313 5.2184L4.34264 7.72477C3.89997 7.90271 3.90211 8.15037 4.26205 8.26077L5.92742 8.78057Z" fill="currentColor"></path>
                        </svg>
                    </a>`;
                    }



                    jQuery('.social-profiles').html(socialMediaLinks);
                } else {
                    jQuery('.social-profiles').parent().hide();
                }

                // Append the ID of the loan to the login and register buttons
                jQuery('.login-button').attr('href', jQuery('.login-button').attr('href') + data[0].appPublicId);
                jQuery('.register-button').attr('href', jQuery('.register-button').attr('href') + data[0].appPublicId);


                callback(data[0]);
            }
            );


    }

    // fetchImmSingleData();




    function generateImmFinancialsChart() {
        jQuery('#financial-info-chart').highcharts({
            chart: {
                type: 'column',
                options3d: {
                    enabled: true,
                    alpha: 15,
                    beta: 15,
                    depth: 50,
                    viewDistance: 25
                },
                plotBorderWidth: 0,
                backgroundColor: 'transparent',
                spacingBottom: 5,
                spacingTop: 5,
                spacingLeft: 5,
                spacingRight: 5,
                height: jQuery(window).outerWidth() > 768 ? 310 : 220,
                width: jQuery('.invest-tabs-content > div').width(),
            },
            title: { text: '' },
            xAxis: {
                title: { text: '' },
                gridLineWidth: 1,
                gridLineColor: '#E5E7EB',
                categories: xAxisCategories,
                crosshair: true,
                labels: {
                    formatter: function () {
                        return this.value;
                    }
                },
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>€{point.y}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                column: {
                    pointPadding: 0.1,
                    // pointWidth: jQuery(window).outerWidth() > 768 ? 20 : 12,
                    borderRadius: 4,
                    plotBorderWidth: 1,
                    borderWidth: 1,
                    groupPadding: 0.35,
                    depth: 100,
                }
            },
            yAxis: {
                min: 0,
                // max: ymax,
                title: { text: '' },
                gridLineWidth: 0,
                gridLineColor: '#F3F4F6',
                labels: {
                    formatter: function () {
                        let tempVal = this.value;
                        if (this.value > 999) tempVal = (this.value / 1000).toFixed(1) + 'K';
                        if (this.value > 999999) tempVal = (this.value / 1000000).toFixed(1) + 'M';
                        if (tempVal == 0) return '';

                        // Separate the thousands by comma
                        tempVal = tempVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                        return '€' + tempVal;
                    },
                },
            },
            legend: { enabled: true, borderWidth: 0 },
            series: immInfoFinanciareData
        });

        // console.log('Done charting');
    }
    generateImmFinancialsChart();

    function generateTable() {
        // Based on the immInfoFinanciare object, generate a table, the years would be the columns and the keys would be the rows
        // The table should be generated in the #financial-info-table div
        // The table should have a header with the years
        // The table should have a body with the keys


        // Get the years
        const years = Object.keys(immInfoFinanciare);

        // Get the keys
        const keys = Object.keys(immInfoFinanciare[years[0]]);

        // Generate the table
        let table = '<table class="table table-striped table-bordered table-hover">';
        table += '<thead><tr>';
        table += '<th></th>';
        years.forEach((year) => {
            table += '<th>Anul ' + year + '</th>';
        }
        );
        table += '</tr></thead>';

        table += '<tbody>';
        keys.forEach((key) => {
            table += '<tr>';

            // Transform camelCase to Camel case
            let title = key.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) { return str.toUpperCase(); });

            // Make only the first letter uppercase and the rest lowercase
            title = title.charAt(0).toUpperCase() + title.slice(1).toLowerCase();

            title = immInfoFinanciareLabels[key];

            table += '<td>' + title + '</td>';
            years.forEach((year) => {

                // Transform the value to a readable format
                let value = immInfoFinanciare[year][key];
                if (key !== 'numarAngajati' && key !== 'raportulImobilizarileNecorporaleSiActive' && key !== 'raportDatoriiCapitaluriProprii') {
                    value = '€' + immInfoFinanciare[year][key].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }

                // Generate the label depending on the value for last year
                let label = '';

                // If it's the first year, don't show the label
                if (year == years[0]) {
                    label = '';
                } else {


                    let differenceInPercentage = ((immInfoFinanciare[year][key] - immInfoFinanciare[year - 1][key]) / immInfoFinanciare[year - 1][key]) * 100;
                    if (immInfoFinanciare[year][key] > immInfoFinanciare[year - 1][key]) {
                        label = '<span class="outline-label green">+' + differenceInPercentage.toFixed(1) + '%</span>';
                    } else if (immInfoFinanciare[year][key] < immInfoFinanciare[year - 1][key]) {
                        label = '<span class="outline-label red">' + differenceInPercentage.toFixed(1) + '%</span>';
                    } else {
                        label = '<span class="outline-label">' + differenceInPercentage.toFixed(1) + '%</span>';
                    }
                }


                table += '<td>' + value + label + '</td>';
            });
            table += '</tr>';
        }
        );
        table += '</tbody>';

        table += '</table>';

        jQuery('#financial-info-table').html(table);

    }
    generateTable();


    const initiliazeCarousel = () => {
        jQuery('.imm-company-carousel').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
        });

        // let thumbsToShow = jQuery('.imm-company-carousel-thumbs > figure').length >= 3 ? 3 : length;

        jQuery('.imm-company-carousel-thumbs').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            asNavFor: '.imm-company-carousel',
            focusOnSelect: true,
        });
    }
    initiliazeCarousel();

}

if (jQuery('.imm-invest-page').length) immFinancePage();

jQuery('#invest-sum').on('change', function () {
    // Sync the value with the button-selector
    const el = jQuery(this);
    const value = el.val();

    // Find the button-selector with this data-target
    const target = jQuery('.button-selector[data-target="' + el.attr('id') + '"]');

    // Check if any of the buttons has the same value and if so, select it
    target.find('.selector-option').each(function () {
        const button = jQuery(this);
        if (button.data('value') == value) {
            button.addClass('selected');
        } else {
            button.removeClass('selected');
        }

        // if the value is more than the prior to last .selector-option then select the last button
        if (value > parseInt(target.find('.selector-option').eq(-2).data('value'))) {
            target.find('.selector-option').eq(-1).addClass('selected');
        }
    });
});